import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="py-24 relative overflow-hidden bg-slate-900/50 border-t border-white/5" data-id="element-222">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-900/10 via-[#0a0e1a]/0 to-[#0a0e1a]/0 pointer-events-none" data-id="element-223" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-224">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-4xl mx-auto" data-id="element-225">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-500/10 text-amber-500 mb-6 border border-amber-500/20" data-id="element-226">
            <span className="text-3xl" aria-hidden="true" data-id="element-227">
              🏆
            </span>
          </div>

          <h2 className="text-sm font-bold tracking-widest text-amber-500 uppercase mb-4" data-id="element-228">
            Close The Gap™
          </h2>

          <h3 className="text-4xl md:text-6xl font-display font-bold text-white mb-6" data-id="element-229">
            MEGAPACK BIOHACKING DEL SUEÑO
          </h3>

          <p className="text-xl md:text-2xl text-slate-300 mb-4 font-medium" data-id="element-230">
            6 Tomos + 6 Bonos — El sistema completo de optimización del sueño
          </p>

          <p className="text-lg text-slate-400 mb-12" data-id="element-231">
            240+ páginas — Todo resuelto. Aplicable desde esta noche.
          </p>

          <div className="flex flex-wrap justify-center gap-3" data-id="element-232">
            {['Biología', 'Nutrición', 'Entorno', 'Mente', 'Emergencia', '21 Días'].map((tomo, i) => <div key={i} className="px-4 py-2 rounded-lg bg-slate-800/60 border border-white/10 text-sm font-medium text-slate-300" data-id="element-233">
                <span className="text-slate-500 mr-2" data-id="element-234">Tomo {i + 1}</span> {tomo}
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}